import { Link } from "@tanstack/react-router";
import { AlertCircle, Home, RotateCcw } from "lucide-react";

import { useEffect } from "react";

import { Alert, AlertDescription, AlertTitle } from "shadcn-ui";
import { Button } from "shadcn-ui";
import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
	CardTitle,
} from "shadcn-ui";

export default function ErrorPage({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error);
	}, [error]);

	return (
		<div className="container mx-auto p-4">
			<Card className="w-full max-w-3xl mx-auto">
				<CardHeader>
					<CardTitle className="text-2xl flex items-center gap-2">
						<AlertCircle className="h-6 w-6 text-destructive" />
						Error
					</CardTitle>
				</CardHeader>
				<CardContent className="space-y-6">
					<Alert variant="destructive">
						<AlertCircle className="h-4 w-4" />
						<AlertTitle>Error</AlertTitle>
						<AlertDescription>
							{error.message ||
								"An unexpected error occurred while tracking your package."}
						</AlertDescription>
					</Alert>
					<p className="text-muted-foreground">
						We apologize for the inconvenience. This could be due to a temporary
						issue or the package information may not be available at the moment.
					</p>
					<div className="space-y-2">
						<h3 className="font-semibold">What you can try:</h3>
						<ul className="list-disc list-inside space-y-1 text-muted-foreground">
							<li>Double-check your tracking number and try again</li>
							<li>Refresh the page or try again later</li>
							<li>Contact our customer support if the issue persists</li>
						</ul>
					</div>
				</CardContent>
				<CardFooter className="flex flex-col sm:flex-row gap-4">
					<Button onClick={() => reset()} className="w-full sm:w-auto">
						<RotateCcw className="mr-2 h-4 w-4" />
						Try Again
					</Button>
					<Button asChild variant="outline" className="w-full sm:w-auto">
						<Link to="/">
							<Home className="mr-2 h-4 w-4" />
							Return to Home
						</Link>
					</Button>
				</CardFooter>
			</Card>
		</div>
	);
}
